import { fromGid } from '@/lib/shopify/gid';
import {
  getCompareAtPriceAmount,
  getElevarCurrencyCode,
  getMoneyAmount,
  getUserData,
  initElevarDataLayer,
  resolveElevarCategory,
} from '@/lib/elevar/shared';
import { ELEVAR_BRAND } from '@/lib/elevar/constants';

/**
 * Pushes `dl_select_item` when a product card is clicked.
 * Should be fired before navigation occurs.
 * Pass `selectedVariant` when the card shows a persisted/selected size (e.g. King).
 */
export default function elevarSelectItem(
  shopifyProduct,
  listPath,
  position,
  pricing,
  selectedVariant,
) {
  if (!shopifyProduct || !initElevarDataLayer()) return;

  const variant = selectedVariant ?? shopifyProduct?.variants?.[0];

  if (!variant) return;

  const { sale, full, hasPriceDifference } = pricing.variant(variant);

  const product = {
    id: variant.sku || '',
    name: shopifyProduct.title || '',
    brand: ELEVAR_BRAND,
    category: resolveElevarCategory(shopifyProduct),
    variant: variant?.title || '',
    price: getMoneyAmount(sale ?? variant?.price),
    compare_at_price: getCompareAtPriceAmount(hasPriceDifference, full, sale ?? variant?.price),
    list: listPath,
    product_id: String(fromGid(shopifyProduct.id || '')),
    variant_id: String(fromGid(variant?.id || '')),
    image: variant.image?.url || shopifyProduct.featuredImage?.url || '',
    position,
  };

  window.ElevarDataLayer.push({
    event: 'dl_select_item',
    user_properties: getUserData(),
    ecommerce: {
      currencyCode: getElevarCurrencyCode(variant),
      click: {
        actionField: {
          list: listPath || '',
          action: 'click',
        },
        products: [product],
      },
    },
  });
}
